import {AfterContentInit, Component, EventEmitter, Inject, ViewChild} from '@angular/core';
import { SpinnerService} from "../../services/spinner/spinner.service";
import {
  CdkDragDrop,
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { MatExpansionModule } from '@angular/material/expansion';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatPaginator, MatPaginatorModule} from "@angular/material/paginator";
import {CommonModule, NgFor} from "@angular/common";
import {MatTabsModule} from "@angular/material/tabs";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {AdaService} from "../../services/ada/ada.service";
import {AtecoService} from "../../services/ateco/ateco.service";
import {IscoService} from "../../services/isco/isco.service";
import {IstatService} from "../../services/istat/istat.service";
import {HttpService} from "../../services/http/http.service";
import {MatSnackBar} from "@angular/material/snack-bar";

//DIALOG CLASSIFICAZIONI
@Component({
  selector: 'classificazioni-dialog',
  templateUrl: './classificazioni-dialog.component.html',
  styleUrls: ['./classificazioni-dialog.component.scss'],
  standalone: true,
  imports: [MatExpansionModule, MatProgressSpinnerModule, MatPaginatorModule, CommonModule, MatTabsModule, MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, MatOptionModule, MatSelectModule, CdkDropListGroup, CdkDropList, NgFor, CdkDrag],
})
export class ClassificazioniDialog implements AfterContentInit {
  onAddClick = new EventEmitter();
  onSaveClick = new EventEmitter();
  elencoAda: any[];
  elencoAdaAssociate: any[];
  elencoAteco: any[];
  elencoAtecoAssociate: any[];
  elencoIsco: any[];
  elencoIscoAssociate: any[];
  elencoIstat: any[];
  elencoIstatAssociate: any[];
  filteredLista: any[] = [];
  filteredListaAssociate: any[] = [];
  searchText: string;
  searchTextAssociate: string;
  classificazioneToFilter: any[];
  classificazioneAssociataToFilter: any[];
  actualIndex: any = 0;
  labels: string[] = ['ADA', 'ATECO', 'ISCO', 'ISTAT'];
  isLoaded: boolean = true;
  aree: any[];
  sottoaree: any;
  sottoarea: any;
  area: any;
  listaProcessi: any;
  processo: any;
  listaSequenze: any;
  sequenza: any;
  actualEvent: any;
  panelOpenState = false;
  pageLength: any;
  pageIndex: number = 0;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    public dialogRef: MatDialogRef<ClassificazioniDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ada: AdaService,
    private ateco: AtecoService,
    private isco: IscoService,
    private istat: IstatService,
    private spinner: SpinnerService,
    private api: HttpService,
    private snackBar: MatSnackBar
  ) { }

  ngAfterContentInit(): void {
    this.spinner.show();
    this.pageLength = this.data.count;


    this.api.getTAreaProfilo().subscribe({
      next: (response: any) => {
        this.aree = response.result;
      }
    })

    if (this.data.element.idProfilo) {
      this.ada.ricercaAdaByIdProfilo(this.data.element.idProfilo).subscribe({
        next: (response: any) => {

          this.elencoAdaAssociate = response.result.listaAda;
          this.filteredListaAssociate = this.elencoAdaAssociate;
          this.classificazioneAssociataToFilter = this.elencoAdaAssociate;
        }
      })
    } else {

      this.ada.ricercaAdaByIdCompetenza(this.data.element.id).subscribe({
        next: (response: any) => {

          this.elencoAdaAssociate = response.result.listaAda;
          this.filteredListaAssociate = this.elencoAdaAssociate;
          this.classificazioneAssociataToFilter = this.elencoAdaAssociate;
        }
      })
    }
  }

  getSottoarea(id: any) {
    this.api.getTipoSottoarea(id).subscribe({
      next: (response: any) => {
        this.sottoaree = response.result;
      }
    })
  }
  onPaginateChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.filterArea(this.actualEvent);
  }


  filterSequenze(event: any) {

    this.searchText = '';
    let data : any  = {
      "tipoArea": this.area,
      "tipoProcesso": this.processo,
      "tipoSequenza": this.sequenza
    }
    switch (this.actualIndex) {
      case 0: {

        if(this.filteredListaAssociate.length){
          data.idsToExclude = this.filteredListaAssociate.map((el : any) => el.id);
        }

        this.ada.ricercaAda(data, this.pageIndex, 10, 1).subscribe({
          next: (response: any) => {
            this.elencoAda = response.result.listaAda;
            this.pageLength = response.result.count;
            this.filteredLista = this.elencoAda
            this.classificazioneToFilter = this.elencoAda
          }
        })
        break;
      }
      case 1: {

        if(this.elencoAtecoAssociate.length){
          data.idsToExclude = this.elencoAtecoAssociate.map((el : any) => el.id);
        }

        this.ateco.ricercaAteco(data, this.pageIndex, 10, 1).subscribe({
          next: (response: any) => {
            this.elencoAteco = response.result.listaAteco;
            this.pageLength = response.result.count;
            this.filteredLista = this.elencoAteco;
            this.classificazioneToFilter = this.elencoAteco;
          }
        })
        break;
      }
    }

  }

  filterSottoArea(event: any) {

    this.searchText = '';
    let data : any = {
      "tipoArea": this.area,
      "tipoSottoarea": this.sottoarea,
    }

    if(this.filteredListaAssociate.length){
      data.idsToExclude = this.filteredListaAssociate.map((el : any) => el.id);
    }

    this.ateco.ricercaAteco(data, this.pageIndex, 10, 1).subscribe({
      next: (response: any) => {
        this.elencoAteco = response.result.listaAteco;
        this.pageLength = response.result.count;
        this.filteredLista = this.elencoAteco;
        this.classificazioneToFilter = this.elencoAteco;
      }
    })
  }

  filterProcessi(event: any, processo: any) {
    this.searchText = '';
    let data: any = {
      "tipoArea": this.area,
      "tipoProcesso": processo
    }
    switch (this.actualIndex) {
      case 0: {

        if(this.filteredListaAssociate.length){
          data.idsToExclude = this.filteredListaAssociate.map((el : any) => el.id);
        }

        this.ada.ricercaAda(data, this.pageIndex, 10, 1).subscribe({
          next: (response: any) => {
            this.elencoAda = response.result.listaAda;
            this.pageLength = response.result.count;
            this.filteredLista = this.elencoAda
            this.classificazioneToFilter = this.elencoAda
          }
        })
        break;
      }
      case 1: {

        if(this.elencoAtecoAssociate.length){
          data.idsToExclude = this.elencoAtecoAssociate.map((el : any) => el.id);
        }

        this.ateco.ricercaAteco(data, this.pageIndex, 10, 1).subscribe({
          next: (response: any) => {
            this.elencoAteco = response.result.listaAteco;
            this.pageLength = response.result.count;
            this.filteredLista = this.elencoAteco;
            this.classificazioneToFilter = this.elencoAteco;
          }
        })
        break;
      }
    }
    this.api.getTipoSequenze(this.area.id, processo.id).subscribe({
      next: (response: any) => {
        this.listaSequenze = response.result;
      }
    })
  }

  filterArea(event: any) {
    this.actualEvent = event;
    this.sottoaree = [];
    // this.listaProcessi = [];
    // this.listaSequenze = [];
    this.listaProcessi = undefined;
    this.listaSequenze = undefined;
    // this.searchText = '';



    switch (this.actualIndex) {

      case 0: {
        let data: any = {};
        let searchType = 1;
        if(event) {
          data = {
            "tipoArea": {
              "id": event.value.id,
              "descrizione": event.value.descrizione,
              "ordinamento": event.value.ordinamento
            }
          }
          this.api.getTipoProcessi(event.value.id).subscribe({
            next: (response: any) => {
              this.listaProcessi = response.result;
            }
          })
        } else {
          searchType = 2;
          data = {
            "descrizione":this.searchText
          }
        }

        if(this.filteredListaAssociate.length){
          data.idsToExclude = this.filteredListaAssociate.map((el : any) => el.id);
        }

        this.ada.ricercaAda(data, this.pageIndex, 10, searchType).subscribe({
          next: (response: any) => {
            this.elencoAda = response.result.listaAda;
            this.pageLength = response.result.count;
            this.filteredLista = this.elencoAda
            this.classificazioneToFilter = this.elencoAda
          }
        })
        break;
      }
      case 1: {
        let data : any = {};
        let searchType = 1;
        if(event) {
          data = {
            "tipoArea": {
              "id": event.value.id,
              "descrizione": event.value.descrizione,
              "ordinamento": event.value.ordinamento
            }
          }
          this.getSottoarea(event.value.id);
        } else {
          searchType = 2;
          data = {
            "descrizione":this.searchText
          }
        }

        if(this.elencoAtecoAssociate.length){
          data.idsToExclude = this.elencoAtecoAssociate.map((el : any) => el.id);
        }


        this.ateco.ricercaAteco(data, this.pageIndex, 10, searchType).subscribe({
          next: (response: any) => {
            this.elencoAteco = response.result.listaAteco;
            this.pageLength = response.result.count;
            this.filteredLista = this.elencoAteco;
            this.classificazioneToFilter = this.elencoAteco;
          }
        })
        break;
      }

      case 2: {

        let data_isco : any  = {
          "descrizione": this.searchText
        }

        if(this.elencoIscoAssociate.length){
          data_isco.idsToExclude = this.elencoIscoAssociate.map((el : any ) => el.id);
        }

        this.isco.ricercaIsco(data_isco, this.pageIndex, 10, 2).subscribe({
          next: (response: any) => {
            this.elencoIsco = response.result.listaIsco;
            this.pageLength = response.result.count;
            this.filteredLista = this.elencoIsco
            this.classificazioneToFilter = this.elencoIsco
          }
        })
        break;
      }

      case 3: {

        let data_istat : any = {
          "nome": this.searchText
        }

        if(this.elencoIstatAssociate.length){
          data_istat.idsToExclude = this.elencoIstatAssociate.map((el : any) => el.id);
        }

        this.istat.ricercaIstat(data_istat, this.pageIndex, 10, 2).subscribe({
          next: (response: any) => {
            this.elencoIstat = response.result.listaIstat;
            this.pageLength = response.result.count;
            this.filteredLista = this.elencoIstat;
            this.classificazioneToFilter = this.elencoIstat;
          }
        })
        break;
      }
    }
  }



  filterList(event: any) {
    if (event.target) {

      this.filteredLista = this.classificazioneToFilter.filter((item: { [x: string]: any; }) => {
        return Object.keys(item).some(key => {
          return String(item[key]).toLowerCase().includes(this.searchText.toLowerCase());
        });
      });
    } else {


      if (this.actualIndex == 2) {
        let data: any = {
          "descrizione":event
        }

        if(this.elencoIscoAssociate.length){
          data.idsToExclude = this.elencoIscoAssociate.map((el : any ) => el.id);
        }

        this.isco.ricercaIsco(data, this.pageIndex, 10, 2).subscribe({
          next: (response: any) => {
            this.elencoIsco = response.result.listaIsco;
            this.pageLength = response.result.count;
            this.filteredLista = this.elencoIsco
            this.classificazioneToFilter = this.elencoIsco
          }
        })
      }

      if (this.actualIndex == 3) {
        let data : any = {
          "nome":event
        }

        if(this.elencoIstatAssociate.length){
          data.idsToExclude = this.elencoIstatAssociate.map((el : any) => el.id);
        }

        this.istat.ricercaIstat(data, this.pageIndex, 10, 2).subscribe({
          next: (response: any) => {
            this.elencoIstat = response.result.listaIstat;
            this.pageLength = response.result.count;
            this.filteredLista = this.elencoIstat
            this.classificazioneToFilter = this.elencoIstat
          }
        })
      }
    }



  }

  searchByString(text: string) {
    this.area = undefined;
    this.listaProcessi = undefined;
    this.listaSequenze = undefined;
    let data : any = {
      "tipoArea":null,
      "tipoProcesso":null,
      "tipoSequenza":null,
      "descrizione": text,
      "codice":null
    }
    if (this.actualIndex == 0) {

      // this.ada.getElencoAda(text + "").subscribe({
      //   next: (response: any) => {
      //     this.elencoAda = response.result.listaAda;
      //     this.filteredLista = this.elencoAda
      //     this.classificazioneToFilter = this.elencoAda
      //   }
      // })

      if(this.filteredListaAssociate.length){
        data.idsToExclude = this.filteredListaAssociate.map((el : any)  => el.id);
      }

      this.ada.ricercaAda(data, this.pageIndex, 10, 2).subscribe({
        next: (response: any) => {
          this.elencoAda = response.result.listaAda;
          this.pageLength = response.result.count;
          this.filteredLista = this.elencoAda
          this.classificazioneToFilter = this.elencoAda
        }
      })

    }

    if (this.actualIndex == 1) {
      if(this.elencoAtecoAssociate.length){
        data.idsToExclude = this.elencoAtecoAssociate.map((el : any) => el.id);
      }

      this.ateco.ricercaAteco(data, this.pageIndex, 10, 2).subscribe({
        next: (response: any) => {
          this.elencoAteco = response.result.listaAteco;
          this.pageLength = response.result.count;
          this.filteredLista = this.elencoAteco
          this.classificazioneToFilter = this.elencoAteco
        }
      })
      //   this.ateco.getElencoAteco(text + "").subscribe({
      //     next: (response: any) => {
      //       this.elencoAteco = response.result.listaAteco;
      //       this.filteredLista = this.elencoAteco
      //       this.classificazioneToFilter = this.elencoAteco
      //     }
      //   })
    }

  }

  associaClassificazioni(lista: any) {
    switch (this.actualIndex) {
      case 0: {
        if (this.data.element.idProfilo) {
          this.ada.salvaAdaByIdProfilo(lista, this.data.element.idProfilo).subscribe({
            next: (response: any) => {
              this.snackBar.open('Classificazioni associate con successo', 'close', { panelClass: 'successSnack' });
            }
          })
        } else {
          this.ada.salvaAdaByIdCompetenza(lista, this.data.element.id).subscribe({
            next: (response: any) => {
              this.snackBar.open('Classificazioni associate con successo', 'close', { panelClass: 'successSnack' });
            }
          })
        }
        break;
      }
      case 1: {
        if (this.data.element.idProfilo) {
          this.ateco.salvaAtecoByIdProfilo(lista, this.data.element.idProfilo).subscribe({
            next: (response: any) => {
              this.snackBar.open('Classificazioni associate con successo', 'close', { panelClass: 'successSnack' });
            }
          })
        } else {
          this.ateco.salvaAtecoByIdCompetenza(lista, this.data.element.id).subscribe({
            next: (response: any) => {
              this.snackBar.open('Classificazioni associate con successo', 'close', { panelClass: 'successSnack' });
            }
          })
        }
        break;
      }
      case 2: {
        if (this.data.element.idProfilo) {
          this.isco.salvaIscoByIdProfilo(lista, this.data.element.idProfilo).subscribe({
            next: (response: any) => {
              this.snackBar.open('Classificazioni associate con successo', 'close', { panelClass: 'successSnack' });
            }
          })
        } else {
          this.isco.salvaIscoByIdCompetenza(lista, this.data.element.id).subscribe({
            next: (response: any) => {
              this.snackBar.open('Classificazioni associate con successo', 'close', { panelClass: 'successSnack' });
            }
          })
        }
        break;
      }
      case 3: {
        if (this.data.element.idProfilo) {
          this.istat.salvaIstatByIdProfilo(lista, this.data.element.idProfilo).subscribe({
            next: (response: any) => {
              this.snackBar.open('Classificazioni associate con successo', 'close', { panelClass: 'successSnack' });
            }
          })
        } else {
          this.istat.salvaIstatByIdCompetenza(lista, this.data.element.id).subscribe({
            next: (response: any) => {
              this.snackBar.open('Classificazioni associate con successo', 'close', { panelClass: 'successSnack' });
            }
          })
        }
        break;
      }
    }

  }

  onTabChanged(e: any) {
    this.searchText = '';
    this.area = undefined;
    this.filteredLista = [];
    this.filteredListaAssociate = [];
    this.actualIndex = e.index;
    this.pageIndex = 0;
    this.pageLength = 0;

    switch (e.index) {
      case 0: {
        if (this.data.element.idProfilo) {
          if (!this.elencoAdaAssociate) {
            this.ada.ricercaAdaByIdProfilo(this.data.element.idProfilo).subscribe({
              next: (response: any) => {

                this.elencoAdaAssociate = response.result.listaAda;
                this.filteredListaAssociate = this.elencoAdaAssociate;
                this.classificazioneAssociataToFilter = this.elencoAdaAssociate;
              }
            });
          } else {
            this.filteredListaAssociate = this.elencoAdaAssociate;
            this.classificazioneAssociataToFilter = this.elencoAdaAssociate;
          }
        } else {
          if (!this.elencoAdaAssociate) {
            this.ada.ricercaAdaByIdCompetenza(this.data.element.id).subscribe({
              next: (response: any) => {

                this.elencoAdaAssociate = response.result.listaAda;
                this.filteredListaAssociate = this.elencoAdaAssociate;
                this.classificazioneAssociataToFilter = this.elencoAdaAssociate;
              }
            });
          } else {
            this.filteredListaAssociate = this.elencoAdaAssociate;
            this.classificazioneAssociataToFilter = this.elencoAdaAssociate;
          }
        }



        break;
      }

      case 1: {
        if (this.data.element.idProfilo) {
          if (!this.elencoAtecoAssociate) {
            this.ateco.ricercaAtecoByIdProfilo(this.data.element.idProfilo).subscribe({
              next: (response: any) => {

                this.elencoAtecoAssociate = response.result.listaAteco;
                this.filteredListaAssociate = this.elencoAtecoAssociate;
                this.classificazioneAssociataToFilter = this.elencoAtecoAssociate;
              }
            });
          } else {
            this.filteredListaAssociate = this.elencoAtecoAssociate;
            this.classificazioneAssociataToFilter = this.elencoAtecoAssociate;
          }
        } else {
          if (!this.elencoAtecoAssociate) {
            this.ateco.ricercaAtecoByIdCompetenza(this.data.element.id).subscribe({
              next: (response: any) => {

                this.elencoAtecoAssociate = response.result.listaAteco;
                this.filteredListaAssociate = this.elencoAtecoAssociate;
                this.classificazioneAssociataToFilter = this.elencoAtecoAssociate;
              }
            });
          } else {
            this.filteredListaAssociate = this.elencoAtecoAssociate;
            this.classificazioneAssociataToFilter = this.elencoAtecoAssociate;
          }
        }
        break;
      }

      case 2: {
        // let data_isco = {
        //   "codiceIsco":"",
        //   "descrizione":""
        // }
        // this.isco.ricercaIsco(data_isco, 0, 3000).subscribe({
        //   next: (response: any) => {
        //     this.elencoIsco = response.result.listaIsco;
        //     this.filteredLista = this.elencoIsco
        //     this.classificazioneToFilter = this.elencoIsco
        //   }
        // })
        if (this.data.element.idProfilo) {
          if (!this.elencoIscoAssociate) {
            this.isco.ricercaIscoByIdProfilo(this.data.element.idProfilo).subscribe({
              next: (response: any) => {

                this.elencoIscoAssociate = response.result.listaIsco;
                this.filteredListaAssociate = this.elencoIscoAssociate;
                this.classificazioneAssociataToFilter = this.elencoIscoAssociate;
              }
            });
          } else {
            this.filteredListaAssociate = this.elencoIscoAssociate;
            this.classificazioneAssociataToFilter = this.elencoIscoAssociate;
          }
        } else {
          if (!this.elencoIscoAssociate) {
            this.isco.ricercaIscoByIdCompetenza(this.data.element.id).subscribe({
              next: (response: any) => {

                this.elencoIscoAssociate = response.result.listaIsco;
                this.filteredListaAssociate = this.elencoIscoAssociate;
                this.classificazioneAssociataToFilter = this.elencoIscoAssociate;
              }
            });
          } else {
            this.filteredListaAssociate = this.elencoIscoAssociate;
            this.classificazioneAssociataToFilter = this.elencoIscoAssociate;
          }
        }
        break;
      }

      case 3: {
        // let data_istat = {
        //   "codiceIstat":"",
        //   "descrizione":"",
        //   "nome":""
        // }
        // this.istat.ricercaIstat(data_istat, 0, 3000).subscribe({
        //   next: (response: any) => {
        //     this.elencoIstat = response.result.listaIstat;
        //     this.filteredLista = this.elencoIstat;
        //     this.classificazioneToFilter = this.elencoIstat;
        //   }
        // })
        if (this.data.element.idProfilo) {
          if (!this.elencoIstatAssociate) {
            this.istat.ricercaIstatByIdProfilo(this.data.element.idProfilo).subscribe({
              next: (response: any) => {

                this.elencoIstatAssociate = response.result.listaIstat;
                this.filteredListaAssociate = this.elencoIstatAssociate;
                this.classificazioneAssociataToFilter = this.elencoIstatAssociate;
              }
            });
          } else {
            this.filteredListaAssociate = this.elencoIstatAssociate;
            this.classificazioneAssociataToFilter = this.elencoIstatAssociate;
          }
        } else {
          if (!this.elencoIstatAssociate) {
            this.istat.ricercaIstatByIdCompetenza(this.data.element.id).subscribe({
              next: (response: any) => {

                this.elencoIstatAssociate = response.result.listaIstat;
                this.filteredListaAssociate = this.elencoIstatAssociate;
                this.classificazioneAssociataToFilter = this.elencoIstatAssociate;
              }
            });
          } else {
            this.filteredListaAssociate = this.elencoIstatAssociate;
            this.classificazioneAssociataToFilter = this.elencoIstatAssociate;
          }
        }
        break;
      }
    }
  }

  drop(event: CdkDragDrop<string[]>) {


    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }



    this.area = undefined;
  }

  dragItem(item: any) {


  }

  filterListAssociate(event: any) {


    this.filteredListaAssociate = this.classificazioneAssociataToFilter.filter((item: { [x: string]: any; }) => {
      return Object.keys(item).some(key => {
        return String(item[key]).toLowerCase().includes(this.searchTextAssociate.toLowerCase());
      });
    });
  }

  competenzaDetail(event: any) {

    this.onAddClick.emit(event);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
